import { InputAdornment, IconButton, Typography } from "@mui/material";
import clsx from "clsx";
import React from "react";

interface IEndAdornmentProps {
	strength?: {
		icon: React.ReactNode;
		text: string;
	};
	showPassword: boolean;
	iconVisible: string;
	iconHidden: string;
	handleOnClick: () => void;
	handleOnMouseDown?: (event: React.MouseEvent<HTMLButtonElement>) => void;
}

export default function EndAdornment(props: Readonly<IEndAdornmentProps>) {
	return (
		<InputAdornment position="end" className="pr-[6px] ml-[10px]">
			{props.strength && (
				<IconButton
					disableFocusRipple
					disableRipple
					aria-label="Password strength indicator"
					edge="end"
					className="absolute right-[40px]"
				>
					{props.strength.icon}
					<Typography
						className={clsx([
							{ "ml-[12px] text-regular font-ptsans min-w-[50px] text-left alert-strength": true },
							{ "text-gray-medium": props.strength.text === "Weak" },
							{ "text-gray": props.strength.text === "Medium" },
							{ "text-primary": props.strength.text === "Strong" },
						])}
					>
						{props.strength.text}
					</Typography>
				</IconButton>
			)}

			<IconButton
				aria-label="Toggle password visibility"
				onClick={props.handleOnClick}
				onMouseDown={(e) => props.handleOnMouseDown?.(e)}
				edge="end"
			>
				{props.showPassword ? (
					<img src={props.iconVisible} className="size-[20px]" alt="Visible indicator" />
				) : (
					<img src={props.iconHidden} className="size-[20px]" alt="Hidden indicator" />
				)}
			</IconButton>
		</InputAdornment>
	);
}
